import { ReactNode, useState } from "react";
import { Box, SxProps, Tab, Tabs, Typography } from "@mui/material";
import BreakdownBySongsTable from "./BreakdownBySongsTable";
import BreakdownByServiceTable from "./BreakdownByServiceTable";
import { ServiceEarning, SongEarning } from "@arelia-types/earnings";
import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";
import { CONSTANTS } from "@arelia-utils/constants/constants";

interface TabPanelProps {
  index: number;
  value: number;
  children?: ReactNode;
}

interface DistrokidDetailsProps {
  loadingSongs: boolean;
  loadingServices: boolean;
  songEarnings: SongEarning[];
  serviceEarnings: ServiceEarning[];
}

const MessageSx: SxProps = {
  mt: 2,
  textAlign: "center"
}

function TabPanel({ children, value, index, ...other }: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0, mb: 2, mt: 1 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `details-tab-${index}`,
    'aria-controls': `details-tabpanel-${index}`,
  };
}

export default function StreamingRoyaltiesPresenter({loadingSongs, loadingServices, songEarnings, serviceEarnings }: DistrokidDetailsProps) {
  const [value, setValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box pb={1}>
      <Box sx={{ backgroundColor: "#fff", borderRadius: "10px", py: 2, px: 3 }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleTabChange} aria-label="details tabs">
            <Tab sx={{ letterSpacing: "0.1em" }} label="Breakdown by song" {...a11yProps(0)} />
            <Tab sx={{ letterSpacing: "0.1em" }} label="Breakdown by service" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <SpinnerWrapper loading={loadingSongs} >
            {songEarnings.length === 0
            ? <Typography sx={MessageSx}>{CONSTANTS.UI_MESSAGES.DISTROKID_AUTH_ERROR}</Typography>
            : <BreakdownBySongsTable rows={songEarnings} />
            }
          </SpinnerWrapper>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <SpinnerWrapper loading={loadingServices} >
            {serviceEarnings.length === 0
            ? <Typography sx={MessageSx}>{CONSTANTS.UI_MESSAGES.DISTROKID_AUTH_ERROR}</Typography>
            : <BreakdownByServiceTable rows={serviceEarnings} />
            }
          </SpinnerWrapper>
        </TabPanel>
      </Box>
    </Box>
  );
}
